import { render } from "./BdcomGponUplinkTable.vue?vue&type=template&id=3467dd15"
import script from "./BdcomGponUplinkTable.vue?vue&type=script&lang=js"
export * from "./BdcomGponUplinkTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__